import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { HttpClientService } from './http-client.service';
import { HttpErrorHandler } from './http-error-handler';

import { NgResponse } from '../shared/ng-response';

import { AppContext } from '../app.context';
import { EntityTypesResponse } from "../shared/entity-types-response";

@Injectable()
export class EntityTypesService extends HttpClientService {
  constructor(
    readonly appContext: AppContext,
    readonly httpClient: HttpClient,
    readonly httpErrorHandler: HttpErrorHandler) {
    super('SecurityService', httpClient, httpErrorHandler);
  }

  getEntityTypes(): Observable<NgResponse<EntityTypesResponse>> {
    return this.get<EntityTypesResponse>('getEntityTypes', 'api/EntityTypes');
  }
}
